(function() {
  var SelectBox, ValidationEngine,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  SelectBox = App.loadClass('core::SelectBox');

  ValidationEngine = App.loadClass('core::ValidationEngine');

  exports.AddEditDialog = (function(superClass) {
    extend(AddEditDialog, superClass);

    function AddEditDialog() {
      this.countCounties = bind(this.countCounties, this);
      this._updateDistribution = bind(this._updateDistribution, this);
      this._updateYieldUnits = bind(this._updateYieldUnits, this);
      this.afterLoadLayout = bind(this.afterLoadLayout, this);
      this.getPostData = bind(this.getPostData, this);
      this.init = bind(this.init, this);
      this.setInitialDeps = bind(this.setInitialDeps, this);
      return AddEditDialog.__super__.constructor.apply(this, arguments);
    }

    AddEditDialog.prototype.setInitialDeps = function() {
      return this.syncDeps({
        'DialogKO': 'portal::viewmodels/zones/AddEditDialog'
      });
    };

    AddEditDialog.prototype.init = function() {
      this.ppID = this.parent.ppID;
      this.layoutUrl = 'backend/portal/zones/zones/load-add-edit-dialog';
      if (this.loadLayoutPostOptions == null) {
        this.loadLayoutPostOptions = {};
      }
      this.loadLayoutPostOptions.pp_id = this.ppID;
      this.saveUrl = 'backend/portal/zones/zones/save';
      this.classes = 'medium_dialog add_edit_zone_dialog';
      this.createDialog();
      this.openDialog();
      this.displayLoadingMessage('Loading Zone...');
      return this.validator = new ValidationEngine();
    };

    AddEditDialog.prototype.getPostData = function() {
      var data, i, input, j, len, len1, name, option, ref, ref1;
      data = {
        counties: []
      };
      ref = this.dialog.find('form [name]');
      for (i = 0, len = ref.length; i < len; i++) {
        input = ref[i];
        input = $(input);
        name = input.attr('name');
        if (name === '') {
          continue;
        }
        switch (name) {
          case 'zone_counties':
            ref1 = input.find('option');
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              option = ref1[j];
              data.counties.push($(option).attr('value'));
            }
            break;
          case 'zone_id':
            data.sz_id = input.val();
            break;
          case 'zone_name':
            data.name = input.val();
            break;
          case 'states':
          case 'state_counties':
            break;
          default:
            data[name] = input.val();
        }
      }
      $.extend(data, this.dialog_ko.toJS());
      return data;
    };

    AddEditDialog.prototype.afterLoadLayout = function(selector, response) {
      var elem, i, key, len, max_key, ref, ref1, self, states;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      self = this;
      states = {};
      ref1 = self.dialog.find('.zone_counties option');
      for (i = 0, len = ref1.length; i < len; i++) {
        elem = ref1[i];
        key = $(elem).attr('data-states-id');
        if (states[key] != null) {
          states[key] += 1;
        } else {
          states[key] = 1;
        }
        if (states[key] > states[max_key] || (typeof max_key === "undefined" || max_key === null)) {
          max_key = key;
        }
      }
      this.dialog.find('.sel_state').val(max_key != null ? max_key : '');
      this.dialog.find('.sel_state').on('change', function() {
        var counties, countysel, j, len1, ref2, states_id, val;
        states_id = $(this).val();
        countysel = self.dialog.find('.state_counties');
        counties = self.taffyObjects['counties']({
          'states_id': {
            '==': states_id
          }
        }).select('id', 'cname');
        SelectBox.render(counties, countysel, []);
        ref2 = self.dialog.find(".zone_counties option[data-states-id='" + states_id + "']");
        for (j = 0, len1 = ref2.length; j < len1; j++) {
          elem = ref2[j];
          val = $(elem).attr('value');
          countysel.find("option[value='" + val + "']").remove();
        }
        return countysel.find('option').attr('data-states-id', states_id);
      });
      this.dialog.find('.btn_county_add').on('click', (function(_this) {
        return function() {
          var fetch;
          fetch = _this.countCounties();
          if (fetch === true) {
            _this.moveOptions(_this.dialog.find('.state_counties'), _this.dialog.find('.zone_counties'));
          }
          _this._updateYieldUnits();
          return _this._updateDistribution();
        };
      })(this));
      this.dialog.find('.btn_county_remove').on('click', (function(_this) {
        return function() {
          var states_id;
          _this.moveOptions(_this.dialog.find('.zone_counties'), _this.dialog.find('.state_counties'));
          states_id = _this.dialog.find('.sel_state').val();
          _this.dialog.find(".state_counties option[data-states-id!='" + states_id + "']").remove();
          _this._updateYieldUnits();
          return _this._updateDistribution();
        };
      })(this));
      this.dialog.find('.sel_state').trigger('change');
      this.dialog.find('.info-popover').clickover({
        html: true,
        container: '.add_edit_zone_dialog',
        placement: 'right',
        trigger: 'hover'
      });
      this.validator.registerRule({
        'selector': '.validate-unique',
        'text': 'Zone Name must be unique',
        'ajax': {
          'url': 'backend/portal/zones/zones/validate-zone-name',
          'data': (function(_this) {
            return function(elem) {
              return {
                'zone_name': elem.val(),
                'zone_id': _this.dialog.find('input[name=zone_id]').val(),
                'pp_id': _this.dialog.find('input[name=pp_id]').val()
              };
            };
          })(this)
        },
        'func': function(data) {
          return data === 'good';
        }
      });
      this.validator.makeFormValidator('edit_zones', '#frm_edit_zones', '#edit_zones_errors', (function(_this) {
        return function(valid) {
          if (valid) {
            return _this.save('Saving...');
          } else {

          }
        };
      })(this));
      this.dialog.find('.save-btn').on('click', (function(_this) {
        return function() {
          return _this.validator.validateForm('edit_zones');
        };
      })(this));
      this.dialog_ko = new (this.getDep('DialogKO'))(this, response.data);
      ko.applyBindings(this.dialog_ko, this.dialog.find('.step1')[0]);
      ko.applyBindings(this.dialog_ko, this.dialog.find('.step2')[0]);
      this._updateYieldUnits();
      this._updateDistribution();
      return this.setPosition();
    };

    AddEditDialog.prototype._updateYieldUnits = function() {
      var count, counties, county, el, i, id, j, len, len1, matchingIDs, max, possibleUnits, ref, ref1, units, yieldMsg, yield_unit_hint;
      counties = this.dialog.find('.zone_counties option');
      if (counties.length) {
        possibleUnits = {};
        for (i = 0, len = counties.length; i < len; i++) {
          county = counties[i];
          id = $(county).attr('data-states-id');
          units = this.taffyObjects.states({
            id: id
          }).first().yield_units;
          if (units == null) {
            continue;
          }
          if (possibleUnits[units] != null) {
            possibleUnits[units] += 1;
          } else {
            possibleUnits[units] = 1;
          }
        }
        max = 0;
        this.bestUnits = null;
        for (units in possibleUnits) {
          count = possibleUnits[units];
          if (count > max) {
            this.bestUnits = units;
          }
        }
        yieldMsg = (function() {
          switch (this.bestUnits) {
            case 'bu/ac':
              return "Soil productivity rated in " + this.bestUnits;
            case 'CPI':
            case 'CSR':
              return "Soil productivity rated using " + this.bestUnits;
            default:
              return '';
          }
        }).call(this);
        this.dialog.find('#yield_unit_msg').html(yieldMsg);
        yield_unit_hint = this.bestUnits ? "(" + this.bestUnits + ")" : '';
        this.dialog.find('#yield_unit_hint').html(yield_unit_hint);
        matchingIDs = this.taffyObjects.states({
          yield_units: this.bestUnits
        }).select('id');
        ref = this.taffyObjects.states().select('id');
        for (j = 0, len1 = ref.length; j < len1; j++) {
          id = ref[j];
          el = this.dialog.find(".sel_state option[value='" + id + "']");
          if (indexOf.call(matchingIDs, id) >= 0) {
            el.prop('disabled', false);
          } else {
            el.prop('disabled', true);
          }
        }
        if ((ref1 = this.bestUnits) === 'CPI' || ref1 === 'CSR') {
          this.dialog_ko.setSoilsDefaults(49, 75);
          return this.dialog_ko.soil_type_max(100);
        } else {
          this.dialog_ko.soil_type_max(500);
          return this.dialog_ko.setSoilsDefaults(99, 150);
        }
      } else {
        this.dialog.find('#yield_unit_msg').html('');
        this.dialog.find('.sel_state option').prop('disabled', false);
        this.dialog_ko.soil_type_max(500);
        return this.dialog_ko.setSoilsDefaults(99, 150);
      }
    };

    AddEditDialog.prototype._updateDistribution = function() {
      var counties, county, highDist, i, len, lowDist, medDist, postParams, ref;
      highDist = this.dialog.find('#high_yield_dist');
      medDist = this.dialog.find('#med_yield_dist');
      lowDist = this.dialog.find('#low_yield_dist');
      counties = [];
      ref = this.dialog.find('.zone_counties option');
      for (i = 0, len = ref.length; i < len; i++) {
        county = ref[i];
        counties.push($(county).attr('value'));
      }
      if (counties.length === 0) {
        highDist.text('N/A');
        medDist.text('N/A');
        lowDist.text('N/A');
      }
      postParams = {
        counties: counties.join()
      };
      return $.post('backend/portal/zones/zones/get-soil-distribution', postParams, (function(_this) {
        return function(response) {
          var dist, ref1, units;
          dist = (ref1 = response.data) != null ? ref1.dist : void 0;
          if (dist == null) {
            _this.dialog.find('.message_writer').message_writer('error', "There was a problem getting the soil productivity distribution for this zone. We'll try to fix it as soon as possible.");
            return;
          }
          units = units === 'CPI' || units === 'CSR' ? "(" + _this.bestUnits + ")" : _this.bestUnits;
          highDist.text(dist.high != null ? dist.high.min + " - " + dist.high.max + " " + units : 'N/A');
          medDist.text(dist.med != null ? dist.med.min + " - " + dist.med.max + " " + units : 'N/A');
          return lowDist.text(dist.low != null ? dist.low.min + " - " + dist.low.max + " " + units : 'N/A');
        };
      })(this));
    };

    AddEditDialog.prototype.countCounties = function() {
      var addTotal, counties, e, elem, existingTotal, from, i, j, k, l, len, len1, len2, len3, newList, ref, ref1, sel, success, to, toAdd, total, val;
      addTotal = 0;
      existingTotal = 0;
      from = this.dialog.find('.state_counties');
      to = this.dialog.find('.zone_counties');
      counties = this.dialog.find('.zone_counties option');
      newList = [];
      if (from.val()) {
        ref = from.val();
        for (i = 0, len = ref.length; i < len; i++) {
          elem = ref[i];
          addTotal += 1;
        }
      }
      for (j = 0, len1 = counties.length; j < len1; j++) {
        elem = counties[j];
        existingTotal += 1;
      }
      total = addTotal + existingTotal;
      if (total > 199) {
        if (existingTotal > 199) {
          success = false;
        } else {
          toAdd = 200 - existingTotal;
          ref1 = from.val();
          for (k = 0, len2 = ref1.length; k < len2; k++) {
            elem = ref1[k];
            if (toAdd > 0) {
              newList.push(elem);
              toAdd -= 1;
            }
          }
          for (l = 0, len3 = newList.length; l < len3; l++) {
            val = newList[l];
            sel = "option[value='" + val + "']";
            from.find(sel).appendTo(to);
            from.find(sel).remove();
          }
          success = false;
        }
      } else {
        success = true;
      }
      try {
        if (success) {
          return success;
        } else {
          throw success;
        }
      } catch (error) {
        e = error;
        this.dialog.find('.message_writer').message_writer('error', 'Maximum number of counties per zone may not exceed 200.', 4000);
        return false;
      }
    };

    return AddEditDialog;

  })(DialogHandler);

}).call(this);
